import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import NewLink from '@/components/newLink';
import { AnswerCard } from '@/components/ui/answerCard/answerCard';

export const AnswersImpl = ({
  action,
  traces,
  match,
  history,
  traceId,
  link,
  workflowContext,
  answers,
  groups,
  linkCreatedByAccount,
  nextActions,
  refetchTraceQuery
}) => {
  const location = {
    search: {
      actionKey: 'answerComment',
      groupKey: link.group.label,
      traceIds: match.params.id
    }
  };
  const matchParamsWithWorklowId = {
    ...match.params,
    wfid: workflowContext.rowId
  };
  const newMatch = {
    ...match,
    ...Object.assign(match.params, matchParamsWithWorklowId)
  };

  const answerData = {
    action,
    traces,
    location,
    traceId,
    workflowRowId: workflowContext.rowId,
    groupLabel: link.group.label,
    groups,
    actionLinkHash: link.linkHash
  };

  const answerCardData = answer => {
    const cardData = {
      linkCreatedByAccount,
      link: answer,
      traceId,
      workflowContext
    };
    return cardData;
  };

  const nextActionsIncludeAnswerComment = nextActions.some(n =>
    n.actions.some(a => a.key === 'answerComment')
  );

  return (
    <div>
      {answers?.length > 0 && (
        <div className="mt-2.5 border-border border-t pt-2.5">
          <h2 className="font-medium text-base">
            {`Answer${answers?.length > 1 ? 's' : ''}`}{' '}
            {answers?.length > 1 && `(${answers?.length})`}
          </h2>
          {answers?.map((answer, i) => (
            <AnswerCard data={answerCardData(answer)} key={i} traceInspector />
          ))}
        </div>
      )}
      {nextActionsIncludeAnswerComment && (
        <NewLink
          answer
          answerAction={action}
          answerData={answerData}
          answerGroupLabel={link.group.label}
          answerTraceId={traceId}
          answerTraces={traces}
          history={history}
          match={newMatch}
          refetchTraceQuery={refetchTraceQuery}
        />
      )}
    </div>
  );
};

AnswersImpl.propTypes = {
  action: PropTypes.object.isRequired,
  traces: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  traceId: PropTypes.string.isRequired,
  link: PropTypes.object.isRequired,
  workflowContext: PropTypes.object.isRequired,
  answers: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  linkCreatedByAccount: PropTypes.object.isRequired,
  nextActions: PropTypes.array.isRequired,
  refetchTraceQuery: PropTypes.func.isRequired
};

export const Answers = withRouter(AnswersImpl);
